import VendorItemList from './VendorItemList';

function Vendors() {
  return <VendorItemList />;
}

export default Vendors;
